import { Box, Button, Stack, Typography } from '@mui/material'
import PointOfSaleIcon from '@mui/icons-material/PointOfSale'

interface PagueNoCaixaProps {
  formaDescricao: string
  valorFormatado: string
  /** Total da conta, quando a pessoa paga só uma parte dela. */
  totalFormatado: string | null
  /** "Comanda 15", "Mesa 12": o que o cliente informa no caixa. */
  identificador: string
  onConcluir: () => void
}

/** Forma de pagar no caixa (dinheiro): o totem não recebe, então diz onde pagar e quanto; quem fecha a conta é o caixa. */
export default function PagueNoCaixa({ formaDescricao, valorFormatado, totalFormatado, identificador, onConcluir }: PagueNoCaixaProps): JSX.Element {
  return (
    <Stack spacing={4} sx={{ flex: '1 0 auto', alignItems: 'center', justifyContent: 'center', p: 3, textAlign: 'center' }}>
      <PointOfSaleIcon color="primary" sx={{ fontSize: 96 }} />

      <Stack spacing={0.5} sx={{ alignItems: 'center' }}>
        <Typography variant="h3" sx={{ fontWeight: 'bold' }}>
          Pague no caixa
        </Typography>

        <Box sx={{ display: 'flex', alignItems: 'flex-end' }}>
          <Typography variant="h1" sx={{ color: 'success.main', fontWeight: '900', fontSize: '64px' }}>
            {valorFormatado}
          </Typography>

          {totalFormatado && (
            <Typography variant="h4" sx={{ pb: 1, pl: 1, color: 'secondary.main', fontWeight: 'bold' }}>
              de {totalFormatado}
            </Typography>
          )}
        </Box>
      </Stack>

      <Stack spacing={1} sx={{ alignItems: 'center', maxWidth: 650 }}>
        <Typography variant="h5">
          Vá até o caixa e informe a {identificador}.
        </Typography>

        <Typography variant="h6" color="text.secondary" sx={{ fontWeight: 400 }}>
          Forma de pagamento: {formaDescricao}
        </Typography>
      </Stack>

      <Button
        variant="contained"
        size="large"
        onClick={onConcluir}
        sx={{ minHeight: 64, borderRadius: 3, textTransform: 'none', px: 5, width: '60%', maxWidth: 520 }}
      >
        <Typography variant="h5" sx={{ fontWeight: 'bold' }}>
          Concluir
        </Typography>
      </Button>
    </Stack>
  )
}
